module.exports = __webpack_public_path__ + "static/media/adv_img_2.e5138ad6.jpg";